<template>
 <v-app>
  <div style="padding: 10px;" v-html="$t('labels.Disclosure')" />
  <div style="padding: 10px;" v-html="$t('messages.Disclosure')" />
 </v-app>
</template>

<script>
export default {

}
</script>
 